import React from "react";

function TourViewerLoading() {
  return (
    <div>
      <h2 className="pulse">Caricamento</h2>
    </div>
  );
}

export default TourViewerLoading;
